import { render, staticRenderFns } from "./TelemetryFailedLoginsComponent.vue?vue&type=template&id=0564bad2&"
import script from "./TelemetryFailedLoginsComponent.vue?vue&type=script&lang=js&"
export * from "./TelemetryFailedLoginsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports